import { createFileRoute } from '@tanstack/react-router';
import { ExpensesSettingsPage } from '../features/settings/ExpensesSettingsPage';

export const Route = createFileRoute('/settings/expenses')({
  component: ExpensesSettingsPage,
});
